import { SET_TOAST, CLEAR_TOAST } from '../actions/toast-actions';

export const initialState = {
  message: '',
};

const toastReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_TOAST:
      return {
        ...state,
        message: action.message,
      };

    case CLEAR_TOAST:
      return { ...initialState };

    default:
      return state;
  }
};

export default toastReducer;
